import React, { useState, useEffect, useRef } from 'react'
import SchoolShowHelmet from 'helmets/SchoolShowHelmet'
import { FormattedMessage } from 'react-intl'
import { Box, Container, Grid, Hidden } from '@material-ui/core'
import { useStyles } from './SchoolShow_style'
import SchoolShowBanner from './components/SchoolShowBanner'
import SchoolPassport from './components/SchoolPassport'
import SchoolOverview from './components/SchoolOverview'
import SchoolFaculties from './components/SchoolFaculties'
import SchoolCampuses from './components/SchoolCampuses'
import ShowPageTabs from 'components/ShowPageTabs/ShowPageTabs'
import { DEFAULT_TAB, getTabFromUrl, updateURL } from 'components/ShowPageTabs/ShowPageTabsHelper'
import SimilarSchools from 'components/SimilarSchools/SimilarSchools'
import RouteMapLink from 'wrappers/RouteMapLink/RouteMapLink'
import Button from 'components/Button/Button'
import SchoolSocialLinks from './components/SchoolSocialLinks'

const SchoolShow = (props) => {
    const { school } = props
    const classes = useStyles()
    const topOfTabsRef = useRef()
    const allTabs = [{ value: 'overview', count: null }, { value: 'faculties', count: school.faculties.length }, { value: 'featured_campuses', count: school.featured_campuses.length }]
    const [selectedTab, setSelectedTab] = useState(getTabFromUrl(allTabs) || DEFAULT_TAB)

    useEffect(() => {
        updateURL(selectedTab, allTabs)
    }, [selectedTab])

    const handleTabSelection = (clickedTab) => {
        if (clickedTab === selectedTab) return

        openTab(clickedTab)
    }

    const openTab = (tab) => {
        setSelectedTab(tab)
        topOfTabsRef.current.scrollIntoView({ behavior: 'smooth' })
    }

    return (
        <>
            <SchoolShowHelmet school={school} />
            <Box className={classes.pageContent}>
                <SchoolShowBanner school={school} topOfTabsRef={topOfTabsRef} />
                <Container maxWidth='lg'>
                    <Grid container spacing={4} className={classes.schoolBodyContainer}>
                        <Grid item xs={12} md={3}>
                            <SchoolPassport
                                school={school}
                                tabs={allTabs}
                                setTab={openTab}
                                selectedTab={selectedTab}
                            />
                        </Grid>
                        <Grid item xs={12} md={9}>
                            {school.paid &&
                                <Hidden smDown>
                                    <Box className={selectedTab === 'overview' && classes.tabBox}>
                                        <ShowPageTabs
                                            tabs={allTabs}
                                            selectedTab={selectedTab}
                                            setTab={openTab}
                                        />
                                    </Box>
                                </Hidden>
                            }
                            {selectedTab === 'overview' &&
                                <SchoolOverview
                                    school={school}
                                    setTab={handleTabSelection}
                                />
                            }
                            {school.paid && selectedTab === 'faculties' && <>
                                <SchoolFaculties school={school} />
                            </>}
                            {school.paid && selectedTab === 'featured_campuses' && <>
                                <SchoolCampuses school={school} />
                            </>}
                            {school.paid && school.url &&
                                <Box className={classes.moreInfoButtonBox}>
                                    <Hidden mdUp>
                                        <SchoolSocialLinks school={school}/>
                                    </Hidden>
                                    <RouteMapLink target='_blank' redirectionUrl={school.url}>
                                        <Button className={classes.moreInfoButtonMain}>
                                            <FormattedMessage id='school_page.faq.more_info_url_main' values={{ school: school.name }}/>
                                        </Button>
                                    </RouteMapLink>
                                </Box>
                            }
                        </Grid>
                    </Grid>
                </Container>
            </Box>
            <SimilarSchools school={school}/>
        </>
    )
}

export default SchoolShow
